import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EventsShowcase from './components/EventsShowcase';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import GalleryPreview from './components/GalleryPreview';
import TrustSpeed from './components/TrustSpeed';
import FAQ from './components/FAQ';
import InquiryForm from './components/InquiryForm';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-black font-sans selection:bg-indigo-500/30">
      <Navbar />
      <main>
        <Hero />
        <EventsShowcase />
        <HowItWorks />
        <Features />
        <GalleryPreview />
        <TrustSpeed />
        <FAQ />
        <InquiryForm />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;